import React from 'react'
import BrowseTasksComponent from '../components/BrowseTasks'

function BrowseTasks() {
  return (
    <div>
      <BrowseTasksComponent />
    </div>
  )
}

export default BrowseTasks